module.exports = __webpack_public_path__ + "img/internet_connection.71f25adb.png";